import { autoinject } from 'aurelia-framework';
import { FilterManager } from 'lib/tables/FilterManager';
import { Filters } from 'elements/Filter';
import { PubSub } from 'lib/event';
import { ServiceReportService } from 'services/service-report-service';
import { TableHeader } from 'components/table/table-content';
import { AsyncErrorHandler } from 'lib/ui';

type TrackingByProductionnrResult = {
  TypeName: string;
  NetId: number;
  NetIdentifier: string;
  Type: string;
  FieldName: string;
  ProductionNr: string;
};

@autoinject
export class NewnetTrackingProductionnrReport {
  protected tableHeaders: TableHeader<TrackingByProductionnrResult>[] = [
    { key: 'TypeName', label: 'general.name', sortable: false },
    { key: 'NetIdentifier', label: 'general.NetId', sortable: false },
    { key: 'Type', label: 'general.type', sortable: false },
    { key: 'FieldName', label: 'general.field', sortable: false },
    { key: 'ProductionNr', label: 'general.productionNumber', sortable: false },
  ];

  protected tableData: TrackingByProductionnrResult[] = [];
  protected ready = true;
  protected exportProgress = false;

  constructor(protected fm: FilterManager, private pubsub: PubSub, private serviceReportService: ServiceReportService) {
    pubsub.sub('filter-manager:filter-changed', () => {
      this.getNewnetTrackingByProductionnrReportData();
    });
  }

  protected async attached() {
    await this.getNewnetTrackingByProductionnrReportData();

    this.fm.init({
      context: 'newnet-tracking-production-report',
      storageKey: 'newnet-tracking-production-report',
      filters: {} satisfies Filters,
      defaultFilters: {},
    });
  }

  protected async getNewnetTrackingByProductionnrReportData() {
    this.ready = false;
    const response = await this.serviceReportService.getNewnetTrackingByProductionnrReport(this.fm.queryFilter);
    this.fm.paginationTotalRecords = +response.headers.get('x-total-count') || 0;
    this.tableData = response.data;
    this.ready = true;
  }

  @AsyncErrorHandler
  async exportNewNetTrackingProductionReport() {
    this.exportProgress = true;
    await this.serviceReportService.getNewnetTrackingByProductionnrReportExport(this.fm.queryFilter);
    this.exportProgress = false;
  }

  protected detached() {
    this.pubsub.unsub();
  }

  protected unbind() {
    this.pubsub.unsub();
  }
}
